export default __webpack_public_path__ + "static/media/mild-graph.e315bf66.svg";